import React from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';

import styles from '../styles/DynamicModal.module.css';

const ChangePassword = () => {
    const { openTimeModal } = useTimeModal();

    const [dbStatus, setDbStatus] = React.useState('checking');
    const [loading, setLoading] = React.useState(true);
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    React.useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await axios.get('/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus('Отсутствует подключение к серверу');
        } finally {
            setLoading(false);
        }
        }

        fetchData();
    }, [])

    const [status, setStatus] = React.useState('');

    const navigate = useNavigate();
    const changePassword = (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        axios.put(`/api/change-password`, {
            currentPassword,
            newPassword,
            confirmPassword
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setStatus('Пароль успешно изменён');
            navigate('/auth/logout');
            openTimeModal('Пароль успешно изменён. В целях безопасности заново войдите в учётную запись', 'success');
        })
        .catch((error) => {
            console.error(error);
            setStatus(`Не удалось изменить пароль: ${error.response?.data.message || error.message}`);
        })
    };

    const closeModal = () => {
        navigate('/')
    }

    return (
        <>
        {loading ? (
        <span style={{display: 'flex', flexDirection: 'column', padding: '10px', boxSizing: 'border-box'}}>
            <a>Загрузка...</a>
        </span>
        ) : dbStatus === 'connected' ? (
        <>
            <a style={{zIndex: '9999'}}><Logo to='/' position='fixed' /></a>
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changePassword(e)}>
                    <div className={styles.header}>
                        <div className={styles.headlineWithBackBtn}>
                            <h1>Изменить данные учётной записи</h1>
                        </div>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        {loading ? (
                            <Loading />
                        ) : (
                            <span style={{width: '320px', margin: '0 auto'}}>
                                <h2 style={{margin: '0 0 0 0', display: 'flex', justifyContent: 'center'}}>Введите нынешний пароль</h2>
                                <input type="password" placeholder='Нынешний пароль' required value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
                                <h2 style={{margin: '0 0 0 0', display: 'flex', justifyContent: 'center'}}>Введите новый пароль</h2>
                                <input type="text" placeholder='Новый пароль' required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                <h2 style={{margin: '0 0 0 0', display: 'flex', justifyContent: 'center'}}>Введите новый пароль повторно</h2>
                                <input type="text" placeholder='Новый пароль повторно' required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                                <button className='button maxWidth' type='submit'>Подтвердить изменение пароля</button>
                            </span>
                        )}
                    </div>
                </form>
            </div>
        </>
        ) : (
            <span style={{display: 'flex', flexDirection: 'column', padding: '10px', boxSizing: 'border-box'}}>
                <a>Система «Поток» в данный момент недоступна.</a>
                <a>Статус: {dbStatus}</a>
            </span>
        )}
        </>
    )
};

export default ChangePassword;
